import styled from 'styled-components';

export const ContentWrapper = styled.p`
    font-size: 12px;
`;
